import Contact from '../../components/common/Contact/Contact';
import './Partnerships.scss';

const Partnerships = () => {
  const footerText =
    "// # $ % @ ' = ) ) ) ] [ [ / / ' ' ' = - \" - \" ~ ^ ; . < > { { { }} ";
  return (
    <div className="partnerships">
      <div className="partnerships__header">
        <h1 className="partnerships__title">Some com a gente!</h1>
        <p className="partnerships__subtitle">Juntos, vamos construir um futuro mais acessível para todos.</p>
      </div>
      <div className="partnerships__content">
        <Contact hideTitle removeMargin />
      </div>
      <div className="partnerships__partners" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '48px', flexWrap: 'wrap', margin: '48px 0 32px 0' }}>
        <img src={require('../../assets/images/partners/fundacaocasa.png')} alt="Fundação Casa" />
        <img src={require('../../assets/images/partners/visaomundial.png')} alt="Visão Mundial" />
        <img src={require('../../assets/images/partners/govsp.png')} alt="Governo de SP" />
        <img src={require('../../assets/images/partners/centrodoimigrante.png')} alt="Centro do Imigrante" />
        <img src={require('../../assets/images/partners/Zendesk.png')} alt="Zendesk" />
        <img src={require('../../assets/images/partners/ARRO.png')} alt="ARRO" />
        <img src={require('../../assets/images/partners/Ampliar.png')} alt="Ampliar" />
      </div>
      <div className="partnerships__footer-bar">
        {[...Array(2)].map((_, i) => (
          <span key={i} style={{ display: 'inline', whiteSpace: 'pre' }}>{footerText.repeat(2)}</span>
        ))}
      </div>
    </div>
  );
};

export default Partnerships;
